import notificationClient from '../../api/notificationClient';
import {
  Health_Url,
  Health_Circuit_Url,
  Health_Circuit_Reset_Url,
  Health_Metrics_Url,
} from '../../api/endpoints';
import type {
  BackendHealthResponse,
  BackendCircuitHealthResponse,
  ChannelType,
} from '../../schema/notification';

export const getHealth = async (): Promise<BackendHealthResponse> => {
  const { data } = await notificationClient.get<BackendHealthResponse>(Health_Url);
  return data;
};

export const getCircuitHealth = async (): Promise<BackendCircuitHealthResponse> => {
  const { data } = await notificationClient.get<BackendCircuitHealthResponse>(Health_Circuit_Url);
  return data;
};

export const resetCircuit = async (channel: ChannelType): Promise<void> => {
  await notificationClient.post(Health_Circuit_Reset_Url(channel));
};

export interface DeliveryMetrics {
  window: string;
  total: number;
  timeSeries: { delivered: number[]; partial: number[]; failed: number[] };
  byChannel: Array<{ label: string; value: number }>;
  bySource: Array<{ label: string; value: number }>;
}

export const getDeliveryMetrics = async (window = '12h'): Promise<DeliveryMetrics> => {
  const { data } = await notificationClient.get<DeliveryMetrics>(Health_Metrics_Url(window));
  return data;
};
